import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApiService } from '../../../../../service/api.service';
import { CoreService } from '../../../../../service/core.service';
import { TranslateService } from '@ngx-translate/core';
//irfan
import { Group } from '../../../../../model/group.model';
import { Ledger } from '../../../../../model/ledger.model';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-expense-tax-payment',
  templateUrl: './expense-tax-payment.component.html',
  styleUrls: ['./expense-tax-payment.component.css']
})
export class ExpenseTaxPaymentComponent implements OnInit {
  @ViewChild('closeModal', { static: false }) closeModal: ElementRef;
  resultobj: any = {};
  info = [];
  pay = {
    pay_no: '',
    pay_date: new Date(),
    pay_acc: { ledger_id : 0 },
    note: '',
    ttlAmount: 0,
    grandTtlAmount: 0,
    ttlVatAmount: 0,
    pay_balance: 0,
    pay_bal_sign: '',
    sup_name:'',
    sup_tax_no:'',
    sup_inv_no:'',
    qty:'',
    van_id:0,
    desc:'',
    ttl_round_off:0,
    godown_id: 0,
    ledgers: [{
      sub_id: '',
      ledger: { ledger_id : 0 },
      amount: <any> '',
      narration: '',
      vatIncExc: 0,
      vat_per: 15,
      vat_amount: 0,
      actlAmount: 0,
      round_off: 0,
      fnlAmount: 0,
      pay_balance: 0,
      pay_bal_sign: '',
      accLoading: false
    }]
  };
  // pay.pay_acc: any = {};
  account = [];
  nonAccount = [];
  isSubmitInProg = false;

  curpage = 1;
  lastpage = 1;
  perpage = 20;
  totalItem = 0;
  curForm = 'Create';
  pageLoadingImg = false;

  langText = {
    create: '',
    update: ''
  };
  nextId = '';
  accLoading = false;
  up: any;
  payPriviewLoader:any;
  printPreview:any;
  cmpny = '';
  userType = '';
//irfan
pageLoadingImg1 = false;
isSubmitInProg1 = false;
  customer = {
    is_supplier:false,
    id: '',
    ledger_id: '',
    name: '',
    alias: '',
    code: '',
    email : '',
    mobile: '',
    vat_no: '',
    op_bal: 0,
    op_bal_type: true,
    brch_id:0,
    usr_type:0,
    add: {
      addr: '',
      zip: '',
      city: '',
      country: '',
      state: '',
      state_code: '',
      fax: ''
    },
    del: {
      addr: '',
      zip: '',
      city: '',
      country: '',
      state: '',
      state_code: '',
      fax: ''
    },
    due_day: '',
    van_line: 0,
    price_group: 1,
    note: ''
  };

  savedTemplate = {
    title_text: '',
    color: '#000',
    email_color: '#000',
    font_size: '12',
    orientation: "P",
    paper: 'A4-P',
    m_left: '',
    m_top: '',
    m_right: '',
    m_bottom: '',
    logo: false,
    header_type: 1,
    header_img: [],
    header_all_page: false,
    header_due: false,
    sl_no: false,
    item_desc: false,
    tax_detail: false,
    tax_type: 0,
    name_type: 'N',
    footer_text: ''
  }
  ledger_name: any;
  ledger_accgrp_id: any;
  ledger_branch_id: any;
  ledger_alias: any;
  ledger_code: any;
  ledger_email: any;
  ledger_mobile: any;
  ledger_due: any;
  ledger_tin: any;
  ledger_address: any;
  ledger_notes: any;
  ledgersel: any;
  selData: any = { ledger_id: null, error: null, ledger_name: null, message: null, };
  group_all: string[];
  ledger_all: string[];
  branch_all: string[];
  leadger: any;
  private modalRef: NgbModalRef;
  closeResult: string;  
  customer_type = false;
  printError: any;
  searchleadger: any;
  supplier = false;
  taxCats = [];
  supp_all = [];
  godowns: any;
  priceGroupList = [];
  ledger_pricegrp_id = 1;
  country_dec: string;
  branch_name: any;
  tempImgUrl: any;
  logoImgUrl: string;
  vans: any;
  allvans: any;
  usr_hide_others_sales_data: any;
  usr_block_pre_date_select: any;
  minDate: Date;

  constructor(private apiService: ApiService, private coreService: CoreService, private translate: TranslateService,private modalService: NgbModal) { }

  ngOnInit() {
    this.branch_name = this.coreService.getUserData('branch_name');
    this.translate.get(['Common.create', 'Common.update']).subscribe((res: string) => {
      this.langText.create = res['Common.create'];
      this.langText.update = res['Common.update'];
      this.curForm = this.langText.create;
    });
    this.usr_hide_others_sales_data = this.coreService.getUserData('usr_hide_othr_sales_data');
    this.getNextPaymentId();
    this.getAllAccount();
    this.getAllNonAccountLedgers();
    this.getInfo(this.curpage);
    this.getAllTaxCategories();
    this.up = this.coreService.getUserPrivilage();
    this.cmpny = this.coreService.getUserData('cmpny');
    this.userType = this.coreService.getUserData('user_type');
    //irfan
    this.getAllGroup();
    this.listGodowns();
    this.apiService.getAllPriceGroup().subscribe((res) => {
      this.priceGroupList = res.data;
    });

    this.country_dec=this.coreService.setDecimalLength();
    this.getTemplete();
    this.searchAllVans('');
    this.usr_block_pre_date_select = this.coreService.getUserData("usr_block_pre_date_select");
    if(this.usr_block_pre_date_select){
      this.minDate= new Date();
    }else{
      this.minDate= new Date(this.coreService.getUserData("branch_open_date"));
    }
  }

  listGodowns() {
    let searchval = new FormData();
    this.apiService.getGodownList(searchval).subscribe((res) => {
      this.godowns = res['data'];

    });
  }
  
  getNextPaymentId() {
    this.apiService.getNextPaymentId().subscribe((res) => {
      this.nextId = res.data.ref_no;
    });
  }
  getAllTaxCategories() {
    this.apiService.getAllTaxCategories().subscribe((res) => {
      this.taxCats = res.data;
      var idx = this.taxCats.findIndex(p => p.taxcat_tax_per==0);
      this.taxCats.splice(idx,1);  
    });
  }
  getAccLedgerBalance() {
    this.accLoading = true;
    this.apiService.getLedgerBalance({ ledger_id: this.pay.pay_acc.ledger_id }).subscribe((res) => {
      this.accLoading = false;
      this.pay.pay_balance = res.data.bal_without_sign;
      this.pay.pay_bal_sign = res.data.bal_sign;
    });
  }

  getLedgerBalance(i) {
    this.pay.ledgers[i].accLoading = true;
    this.apiService.getLedgerBalance({ ledger_id: this.pay.ledgers[i].ledger.ledger_id }).subscribe((res) => {
      this.pay.ledgers[i].accLoading = false;
      this.pay.ledgers[i].pay_balance = res.data.bal_without_sign;
      this.pay.ledgers[i].pay_bal_sign = res.data.bal_sign;
    });
  }
  
  getTemplete() {

    this.apiService.getSettings().subscribe((res) => {

      this.savedTemplate = {
        title_text: res.data.prnt_title_text,
        color: '#000',
        email_color: '#000',
        font_size: '12',
        orientation: "P",
        paper: 'A4-P',
        m_left: '',
        m_top: '',
        m_right: '',
        m_bottom: '',
        logo: res.data.prnt_header_logo,
        header_type: res.data.prnt_header_type,
        header_img: [],
        header_all_page: false,
        header_due: false,
        sl_no: false,
        item_desc: false,
        tax_detail: false,
        tax_type: 0,
        name_type: 'N',
        footer_text: res.data.prnt_display_footer_text
      }
      if (res.data.prnt_header_logo) {
        this.logoImgUrl = this.apiService.PHP_API_SERVER + '/' + res.data.prnt_header_logo_img_path;
      } else {
        this.logoImgUrl = '';
      }

      if (res.data.prnt_header_type == 2) {
        this.tempImgUrl = this.apiService.PHP_API_SERVER + '/' + res.data.prnt_header_img_path;
      } else {
        this.tempImgUrl = '';
      }

    });
  }
  getInfo(pageNo) {
    let searchval = new FormData();   
    if(this.usr_hide_others_sales_data){ 
      let hide_other='hide';
      searchval.append("hide_others", hide_other);
    }
    this.pageLoadingImg = true;
    this.apiService.getAllExpenceTaxPayment(searchval,pageNo, this.perpage).subscribe((res) => {
      this.info = res.data.data;
      this.pageLoadingImg = false;
      this.curpage = res.data.current_page;
      this.lastpage = res.data.last_page;
      this.totalItem = res.data.total;
    });
  }

  searchInp(e) {
    this.pageLoadingImg = true;

    const searchval = new FormData();
    searchval.append('search', e);
    if(this.usr_hide_others_sales_data){ 
      let hide_other='hide';
      searchval.append("hide_others", hide_other);
    }
    // searchval.append('is_exp_tax_payment', '1');
    this.pageLoadingImg = true;
    this.apiService.getAllExpenceTaxPayment(searchval,1, this.perpage).subscribe((res) => {
      this.info = res.data.data;
      this.pageLoadingImg = false;
      this.curpage = res.data.current_page;
      this.lastpage = res.data.last_page;
      this.totalItem = res.data.total;
     });
  }

  getAllAccount() {
    this.apiService.getAllAccount().subscribe((res) => {
      this.account = res.data;
    });
  }
  getAllNonAccountLedgers() {
    this.apiService.getAllNonAccountLedgers().subscribe((res) => {
      this.nonAccount = res.data;
    });
  }
  // addMore() {
  //   this.pay.ledgers.push({
  //     sub_id: '',
  //     ledger: { ledger_id : 0 },
  //     amount: 0.00,
  //     narration: '',
  //     vatIncExc: 0,
  //     vat_per: 0,
  //     vat_amount: 0,
  //     actlAmount: 0,
  //     round_off,
  //     fnlAmount: 0,
  //     pay_balance: 0,
  //     pay_bal_sign: '',
  //     accLoading: false
  //   });
  // }
  remove(index) {
    this.pay.ledgers.splice(index, 1);
    this.updateTotoal();
  }
  createPay(){
    this.curForm = this.langText.create;
    this.nextId = '';
    this.getNextPaymentId();
    this.clearForm();
  }
  clearForm() {
    this.pay = {
      pay_no: '',
      pay_date: new Date(),
      pay_acc: { ledger_id : 0 },
      note: '',
      ttlAmount: 0,
      grandTtlAmount: 0,
      ttlVatAmount: 0,
      pay_balance: 0,
      pay_bal_sign: '',
      sup_name:'',
      sup_tax_no:'',
      sup_inv_no:'',
      qty:'',
      van_id:0,
      desc:'',
      ttl_round_off:0,
      godown_id: 0,
      ledgers: [{
        sub_id: '',
        ledger: { ledger_id : 0 },
        amount: '',
        narration: '',
        vatIncExc: 0,
        vat_per: 15,
        vat_amount: 0,
        actlAmount: 0,
        round_off:0,
        fnlAmount: 0,
        pay_balance: 0,
        pay_bal_sign: '',
        accLoading: false
      }]
    };
  }

  updateRoundSign(index) {
    this.pay.ledgers[index].round_off = -1 * Number(this.pay.ledgers[index].round_off);
    this.vatCalculate(index);

  }
  vatCalculate(index) {
    this.pay.ledgers[index].amount = this.pay.ledgers[index].amount || 0;
    if (this.pay.ledgers[index].vatIncExc == 0) {
      // this.pay.ledgers[index].fnlAmount = this.pay.ledgers[index].amount;
      this.pay.ledgers[index].vat_amount = (this.pay.ledgers[index].amount / 100 ) * this.pay.ledgers[index].vat_per;
      this.pay.ledgers[index].fnlAmount = Number(this.pay.ledgers[index].amount) + Number(this.pay.ledgers[index].vat_amount) + Number(this.pay.ledgers[index].round_off);
      this.pay.ledgers[index].actlAmount = this.pay.ledgers[index].amount;
    } else {
      this.pay.ledgers[index].actlAmount = this.pay.ledgers[index].amount / ( 1 + (this.pay.ledgers[index].vat_per / 100));
      this.pay.ledgers[index].vat_amount = (this.pay.ledgers[index].actlAmount  / 100 ) * this.pay.ledgers[index].vat_per;
      this.pay.ledgers[index].fnlAmount = Number(this.pay.ledgers[index].amount) + Number(this.pay.ledgers[index].round_off);
    }
    this.updateTotoal();
    // alert(this.pay.ledgers[index].amount);

    // alert(this.pay.ledgers[index].vatIncExc);
    // alert(this.pay.ledgers[index].vat_per);
  }

  // checkTabClicked(keycode) {
  //   console.log(keycode);
  //   if (keycode.keyCode === 9) {
  //     this.addMore();
  //   }
  // }

  updateTotoal(){
    this.pay.ttlAmount = 0;
    this.pay.ttlVatAmount = 0;
    this.pay.grandTtlAmount = 0;
    this.pay.ttl_round_off = 0;
    this.pay.ledgers.forEach(element => {
      this.pay.grandTtlAmount += Number(element.fnlAmount);
      this.pay.ttlVatAmount += Number(element.vat_amount);
      this.pay.ttlAmount += Number(element.actlAmount);
      this.pay.ttl_round_off += Number(element.round_off);
    });
  }

  voidPayment(id,index){
    // const confrm = confirm('Do you wish to continue?');
    if (confirm('Are you sure to void this record ?')) {
      this.info[index].void_in_progress = true;
      this.apiService.voidPayment({pay_no: id}).subscribe((res) => {
        // console.log(this.staff);
        this.isSubmitInProg = false;
        if (res.error != null) {
          this.resultobj = res.error;
        } else {
          this.getInfo(this.curpage);
          $('.close').click();

          this.coreService.showMessage(res.message);
        }

      });
    }
  }

  editVoucher(pay_no){
    this.nextId = '';
    this.curForm = this.langText.update;
    this.clearForm();
    this.resultobj = [];
    this.apiService.getPayment({rec_no: pay_no}).subscribe((res) => {
        this.nextId = res.pay_no;
        const result = this.account.filter(acc => acc.ledger_id == res.pay_acc_ledger_id);
        this.pay.pay_no = res.pay_no;
        this.pay.pay_date = new Date(res.pay_datetime);
        this.pay.pay_acc =result[0];
        this.getAccLedgerBalance();
        this.pay.note = res.pay_note;
        this.pay.sup_name = res.etp_supplier_name;
        this.pay.sup_tax_no = res.etp_supplier_tax_no;
        this.pay.sup_inv_no = res.etp_supplier_inv_no;
        this.pay.qty = res.etp_qty;
        this.pay.desc = res.etp_desc;
        this.pay.godown_id = res.godown_id;
        this.pay.ledgers = [];
        res.particulars.forEach((element,i) => {
          const result = this.nonAccount.filter(nonacc => nonacc.ledger_id == element.ledger_id);
          var tmpRow = {
            sub_id: element.paysub_id,
            ledger: result[0],
            amount: (element.paysub_vat_inc == 0) ? element.paysub_ttl_amount :(element.paysub_ttl_amount+element.paysub_vat_amt),
            narration: element.paysub_narration,
            vatIncExc: element.paysub_vat_inc,
            vat_per: element.paysub_vat_per,
            vat_amount: element.paysub_vat_amt,
            actlAmount: element.paysub_amount - element.paysub_vat_amt,
            // be care fully check if tax include exclud e option integrating
            round_off: element.pay_sub_roundoff,
            fnlAmount: element.paysub_amount,
            pay_balance: 0,
            pay_bal_sign: '',
            accLoading: true
          };
          this.pay.ledgers.push(tmpRow);
          this.getLedgerBalance(i);
          this.pay.van_id = element.paysub_van_id;
        });
        this.vatCalculate(0);
        this.updateTotoal();
    });
  }

  validateAndSubmit() {
    this.resultobj = [];

    if (this.pay.pay_date == undefined) {
      this.resultobj.pay_date = "t";
      this.resultobj.push({ 'pay_date': 'Required' });
    }
    else {
      if (this.pay.pay_date > new Date()) {
        this.resultobj.pay_date = "t";
        this.resultobj.push({ 'pay_date': 'Required' });
      } 
    }
    if (this.resultobj.length <= 0) {

    if (confirm('Do you wish to continue?')) {
      this.isSubmitInProg = true;
      let callFunction = '';
      if (this.curForm === this.langText.create) {
        callFunction = 'createExpanseTaxPayment';
      }
      if (this.curForm === this.langText.update) {
        callFunction = 'updateExpanseTaxPayment';
      }
      this.apiService[callFunction](this.pay).subscribe((res) => {
        // console.log(this.staff);
        this.isSubmitInProg = false;
        if (res.error != null) {
          this.resultobj = res.error;
        } else {
          this.closeModal.nativeElement.click();
          this.getInfo(this.curpage);
          this.coreService.showMessage(res.message);
          this.clearForm();
          this.getNextPaymentId();
          this.resultobj = {};
        }

      });
    }
  }
  }

  viewPayment(pay_no){
    this.payPriviewLoader = true;
    this.apiService.getTaxPayment({pay_no: pay_no}).subscribe((res) => {
      this.payPriviewLoader = false;
      this.printPreview = res.data;
      console.log(this.printPreview);
    });
  }

  //irfan
  removeName() {
    this.ledger_all = [];
    $('.prev-list').hide();
  }

  getAllGroup() {
    this.apiService.readAllGrp().subscribe((res: Group[]) => {
      // console.log(res['data']);
      const LedgGroup = res['data'].filter((group) => group.accgrp_id !== 21);
      this.group_all = LedgGroup;
    });
  }
  openModal(content: any, size) {

    this.modalRef = this.modalService.open(content, { size: size, backdrop: 'static' });
    this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  validateAndSubmit1(){
    this.isSubmitInProg1 = true;
    let callFunction = 'createCustomer';
    
    if(this.userType =='ADMIN'){
      this.customer.usr_type = 1;
    }else{
      this.customer.usr_type = 0;
    
    }
    this.customer.is_supplier = this.supplier;
    this.apiService[callFunction](this.customer).subscribe((res) => {
      // console.log(this.staff);
      this.isSubmitInProg1 = false;
      if (res.error != null) {
        this.resultobj = res.error;
      } else {
        
        this.coreService.showMessage(res.message);
        // this.clearForm();
        this.resultobj = {};
        this.modalRef.close();
        this.clearCustForm();
        this.supplier = false;
        this.customer_type = false;
        this.getAllNonAccountLedgers();
      }

    });
  }
  createSupplier(formgroup: { value: any; }) {
    this.validatesupplier(formgroup.value);
    if (this.printError.length <= 0) {
      this.pageLoadingImg1 = true;
      
    if(this.userType =='ADMIN'){
      formgroup.value.usr_type = 1;
    }else{     
      formgroup.value.usr_type = 0;
    
    }

    this.apiService.createSupplier(formgroup.value).subscribe((res) => {
      this.pageLoadingImg1=false;

      if (res.error != null) {
        this.resultobj = res.error;
        this.resultobj = this.coreService.getValidation(this.resultobj);
      } else {
        this.coreService.createfunct(formgroup, this.resultobj, res.message);
        this.resultobj = {};
        this.modalRef.close();
        this.supplier = false;
        this.getAllNonAccountLedgers();
      }

    });
  }
  }
  validatesupplier(list) {
   
    this.printError = [];
    if (!list.supp_name) {
      this.printError.push({ 'supp_name': 'Required' });
      $('.supp_name').css("border", "1px solid red");
      $(".supp_name_err").text("Supplier name required");
    } else {
      $('.supp_name').css("border", "1px solid #dedede");
      $(".supp_name_err").text("");
    }
}
createLedger(formgroup: { value: any; }) {
  this.pageLoadingImg1 = true;
  this.apiService.createLedgerPopup(formgroup.value).subscribe((res: Ledger) => {
    this.pageLoadingImg1 = false;

    if (res.error != null) {
      this.resultobj = res.error;
      this.resultobj = this.coreService.getValidation(this.resultobj);
    }
    else {
      this.coreService.createfunct(formgroup, this.resultobj, res.message);
      this.resultobj = {};
      this.modalRef.close();
      this.getAllNonAccountLedgers();
    }

  });
}
searchLedger(search: string) {
  let searchval = new FormData();
  searchval.append("search", search);
  this.apiService.searchLedgerList(searchval, 1).subscribe((res) => {
    this.searchleadger = res['data']['data'];
    // console.log(this.searchleadger);
  });
  $('.prev-list').show();
}
clearCustForm() {
  this.customer = {
    is_supplier:false,
    id: '',
    ledger_id: '',
    name: '',
    alias: '',
    code: '',
    email : '',
    mobile: '',
    vat_no: '',
    op_bal: 0,
    op_bal_type: true,
    brch_id:0,
    usr_type:0,
    add: {
      addr: '',
      zip: '',
      city: '',
      country: '',
      state: '',
      state_code: '',
      fax: ''
    },
    del: {
      addr: '',
      zip: '',
      city: '',
      country: '',
      state: '',
      state_code: '',
      fax: ''
    },
    due_day: '',
    van_line: 0,
    price_group: 1,
    note: ''
  };
}

searchSuppliers(search: any) {
  let searchval = new FormData();
  searchval.append("supp_name", search);
  this.apiService.gettaxSuppByName(searchval).subscribe((res) => {
    this.supp_all = res['data'];
  });
}

searchTaxSubByTaxNo(search: any) {
  let searchval = new FormData();
  searchval.append("vat_no", search);
  this.apiService.gettaxSuppByVatNo(searchval).subscribe((res) => {
    this.supp_all = res['data'];
    if(res['data'] && res['data'].length > 0 ){
      this.pay.sup_name= res['data'][0].etp_supplier_name;
    }else{
      this.pay.sup_name = '';
    }
  });
}
searchVans(search: string) {
  const searchval = new FormData();
  searchval.append('van_name', search);
  this.apiService.searchVans(searchval).subscribe((res) => {
    
    this.vans = res['data'];
  });

}

searchAllVans(search: string) {
  const searchval = new FormData();
  searchval.append('van_name', search);
  this.apiService.searchVans(searchval).subscribe((res) => {
    
    this.allvans = res['data'];
    this.vans = res['data'];
  });

}

updateSuppTax(supp_name){
  // console.log(supp_name);
  const selSupp = this.supp_all.filter(supp => supp.etp_supplier_name == supp_name);
  if(selSupp.length > 0){
    this.pay.sup_tax_no = selSupp[0].etp_supplier_tax_no;
  }
  // console.log(selSupp);
}


}
